// @flow
import { createAction } from 'redux-actions';
import * as constants from './constants';

export const analyticsSharingToggled = createAction(constants.ANALYTICS_SHARING_TOGGLED);
export const pinSet = createAction(constants.PIN_SET);
export const resetPinError = createAction(constants.RESET_PIN_ERROR);
export const setPin = createAction(constants.SET_PIN);
export const settingPin = createAction(constants.SETTING_PIN);
export const toggleAnalyticsSharingAllowed = createAction(constants.TOGGLE_ANALYTICS_SHARING_ALLOWED);



// WEBPACK FOOTER //
// ./src/core/state/user/actions.js